import CaseFile from "@/models/CaseFile";
import GameScore from "@/models/GameScore";
import Constants from "@/config/constants";

//intro
import { Zoro001IntroInitialHomeScene } from "@/assets/data/pointandclick/scenes/ZORO-001/intro/ZORO-001-intro-initial_home";
import { Zoro001IntroFirstTalkRecipientScene } from "@/assets/data/pointandclick/scenes/ZORO-001/intro/ZORO-001-intro-first_talk_recipient";
import { Zoro001IntroSecondaryTalkRecipientScene } from "@/assets/data/pointandclick/scenes/ZORO-001/intro/ZORO-001-intro-secondary_talk_recipient";
import { Zoro001IntroCollectItemsScene } from "@/assets/data/pointandclick/scenes/ZORO-001/intro/ZORO-001-intro-collect_items";
import { Zoro001IntroFindRecipientScene } from "@/assets/data/pointandclick/scenes/ZORO-001/intro/ZORO-001-intro-find_recipient";
import { Zoro001IntroGoalSeekerScene } from "@/assets/data/pointandclick/scenes/ZORO-001/intro/ZORO-001-intro-goal_seeker";
import { Zoro001IntroGoalSeekerPastScene } from "@/assets/data/pointandclick/scenes/ZORO-001/intro/ZORO-001-intro-goal_seeker_past";
import { Zoro001IntroGoalSeekerPresentScene } from "@/assets/data/pointandclick/scenes/ZORO-001/intro/ZORO-001-intro-goal_seeker_present";
import { Zoro001IntroGoalSeekerFutureScene } from "@/assets/data/pointandclick/scenes/ZORO-001/intro/ZORO-001-intro-goal_seeker_future";
import { Zoro001IntroStepWrapUpTalkScene } from "@/assets/data/pointandclick/scenes/ZORO-001/intro/ZORO-001-intro-step_wrap_up_talk";

//followup
import { Zoro001FollowupInitialHomeScene } from "@/assets/data/pointandclick/scenes/ZORO-001/followup/ZORO-001-followup-initial_home";
import { Zoro001FollowupCollectItemsScene } from "@/assets/data/pointandclick/scenes/ZORO-001/followup/ZORO-001-follow-up-collect_items";
import { Zoro001FollowupFirstTalkRecipientScene } from "@/assets/data/pointandclick/scenes/ZORO-001/followup/ZORO-001-followup-first_talk_recipient";
import { Zoro001FollowupSecondaryTalkRecipientScene } from "@/assets/data/pointandclick/scenes/ZORO-001/followup/ZORO-001-followup-secondary_talk_recipient";
import { Zoro001FollowupTalkAboutItemsScene } from "@/assets/data/pointandclick/scenes/ZORO-001/followup/ZORO-001-followup-step_wrap_up_talk";
import { Zoro001FollowupFindRecipientScene } from "@/assets/data/pointandclick/scenes/ZORO-001/followup/ZORO-001-followup-find_recipient";

import {
    Zoro001Amina,
    Zoro001Annika,
    Zoro001Andreas,
    Zoro001Guy, Zoro001Jack,
    Zoro001Jan,
    Zoro001Josefien,
    Zoro001Julia,
    Zoro001Karim,
    Zoro001Stien,
    Zoro001Tine
} from "@/assets/data/people/people";

import {
    Art,
    Helmet,
    Dog,
    Flowers,
    Photo,
    Wheelchair,
    CellPhone,
    Gift, Datasheet
} from "@/assets/data/items/collection_items-ZORO-001";
import { Zoro001IntroGoalSeekerWrapUpTalkScene } from "@/assets/data/pointandclick/scenes/ZORO-001/intro/ZORO-001-intro-goal_seeker_wrap_up_talk";
import {
    Airbag, EWheelChair, FallDetectionShoes,
    Lamp,
    LifestyleDetector,
    Phone,
    Smartclip, SpeakerCamera,
    Stairgate, Walker
} from "@/assets/data/technological_aids/technological_aids";

export const casefile = new CaseFile({
// export default new CaseFile({
    id: "ZORO-001",
    enabled: true,
    version: "0.4.0",
    caseInfo: "Mijn naam is Stien, 59 jaar. Ik heb een hersenbloeding gehad. Hierdoor ben ik gedeeltelijk verlamd aan mijn linkerzijde. Daardoor ben ik minder mobiel en heb ik last van evenwichtsstoornissen.",
    caseSetting: "Thuiszorg",
    recipient: {
        id: "stien",
        firstname: "Stien",
        lastname: "Martens",
        age: 59,
        backstory: "In eerste instantie kon ze niet zitten, maar door de vele oefeningen met de fysiotherapeut (*) en dankzij haar wilskracht, evolueerde\nze naar terug traag stappen met een hulpmiddel. Haar linkerhand is niet meer verbeterd.\n \nStien doorliep de eerste maanden na de hersenbloeding een heus aanvaardingsproces. Dit ging met ups en downs. Het afhankelijk zijn van anderenen dit zelfs voor de meest normale zaken, zoals douchen, is voor haar het ergste. Door deze halfzijdige verlamming is Stien niet in de mogelijkheid om voor haarkleinkinderen te zorgen. Zo kan ze bijvoorbeeld geen luier verversen van haarkleinkind. Die rol willen, maar niet kunnen opnemen, dat is zwaar om dragen. Deene dochter van Stien is fysiotherapeute en zij is het gewoon om met zorgontvangers zoals Stien om te gaan: de leefwereld van een revaliderende zorgontvanger is voor haar bekend terrein. De andere dochter van Stien is minder vertrouwd met de nieuwe leefwereld van Stien. Ze bedoelt het heel goeden ze probeert Stien te betrekken, maar tegelijk stelt ze soms activiteiten voor die moeilijk zijn voor Stien.\nHet huis van Stien en Jan werd aangepast aan Stien haar noden. Hierbij kregen ze ondersteuning van een ergotherapeut, verbonden aan het ziekenhuis waar ze opgenomen was na de hersenbloeding. Heel wat aanpassingen werden doorgevoerd, zoals de verbreding van de toiletdeur, het plaatsen van een trapleuning langs beide kanten, leuningen aan het zwembad….\nNaast de medische begeleiding en ondersteuning heeft Stien ook nog hulp aan huis. Wekelijks komt een huishoudhulp vier uur strijken en vier uur poetsen. Vroeger stond Stien erop dat haar woning er steeds opgeruimd en netjes bij lag,\nmaar daar is ze veel in veranderd. Haar huis hoeft niet meer zo spik en span te zijn, dat lukt trouwens ook niet meer. Stien haar partner kookt vaak, hij doet het steeds liever, zeker als het BBQ is. Stien helpt waar mogelijk door bijvoorbeeld soep te maken. Stien heeft een lieve en ondeugende hond. Ze haalt heel veel energie uit het gezelschap van haar hond.",
        misc: {
            profession: "Podologe",
            partner: {
                name: "Jan"
            },
            childCount: 4
        }
    },
    team: [
        Zoro001Stien,
        Zoro001Tine,
        Zoro001Julia,
        Zoro001Karim,
        Zoro001Amina,
        Zoro001Josefien,
        Zoro001Annika,
        Zoro001Jan,
        Zoro001Guy,
        Zoro001Andreas,
        Zoro001Jack
    ],
    technologicalAids: [
        Lamp,
        Phone,
        Airbag,
        Smartclip,
        LifestyleDetector,
        Stairgate,
        FallDetectionShoes,
        EWheelChair,
        Walker,
        SpeakerCamera
    ],
    steps: [
        {
            id: "intro",
            name: "Kennismaking en zorgvraag cliënt",
            includeTodo: true,
            documents: [],
            phases: [
                {
                    id: "dashboard",
                    view: "dashboard",
                    properties: {
                        phone: {
                            hints: [
                                {
                                    text: "Je kan de zorgvrager bezoeken via jouw afspraak in de 'Agenda' app of via jouw 'Contacten'",
                                    penalty: Constants.SCORE_TYPES.INTRA_PRENEURSHIP
                                }
                            ]
                        },
                        notification: {
                            app: "agenda",
                            header: {
                                icon: require("@/assets/images/UI/phone/icon_calendar.png"),
                                title: "Agenda"
                            },
                            body: {
                                title: "Afspraak vandaag",
                                description: "Kennismaking met Stien en zorgvraag bepalen."
                            },
                            callToAction: {
                                type: "location",
                                text: "Bezoek Stien",
                                action: "visit_recipient"
                            },
                            idleTime: 10000,
                            autoDisplay: 20000
                        }
                    },
                    actions: [
                        {
                            action: "visit_recipient",
                            phase: "heading_to_recipient"
                        }
                    ],
                    triggers: []
                },
                {
                    id: "heading_to_recipient",
                    view: "gps",
                    title: "GPS",
                    properties: {
                        location: "test"
                    },
                    triggers: [
                        {
                            trigger: "load-phase",
                            auto: true,
                            duration: 2000,
                            phase: "initial_home"
                        }
                    ]
                },
                {
                    id: "initial_home",
                    view: "free_roam",
                    properties: {
                        phone: {
                            disabledApps: [
                                'contacts',
                                'agenda',
                                'files'
                            ],
                            hints: [
                                {
                                    text: "Je bent  aangekomen bij je cliënt. Druk op de deurbel.",
                                    penalty: Constants.SCORE_TYPES.INTRA_PRENEURSHIP
                                }
                            ]
                        },
                        location: "outside",
                        objects: [
                            "doorbell"
                        ],
                        scene: Zoro001IntroInitialHomeScene,
                    },
                    actions: [
                        {
                            action: "press_doorbell",
                            phase: "initial_home_waiting"
                        }
                    ]
                },
                {
                    id: "initial_home_waiting",
                    view: "free_roam",
                    properties: {
                        phone: {
                            disabledApps: [
                                'contacts',
                                'agenda',
                                'files'
                            ]
                        },
                        scene: Zoro001IntroInitialHomeScene,
                    },
                    triggers: [
                        {
                            trigger: "load-phase",
                            auto: true,
                            duration: 2000,
                            phase: "first_talk_recipient"
                        }
                    ]
                },
                {
                    id: "first_talk_recipient",
                    view: "free_roam",
                    properties: {
                        phone: {
                            disabledApps: [
                                'contacts',
                                'agenda',
                                'files'
                            ],
                            hints: [
                                {
                                    text: "Praat met Stien.",
                                    penalty: Constants.SCORE_TYPES.INTRA_PRENEURSHIP
                                }
                            ]
                        },
                        location: "hallway",
                        objects: [
                            "recipient"
                        ],
                        scene: Zoro001IntroFirstTalkRecipientScene
                    },
                    actions: [
                        {
                            action: "talk_with_recipient",
                            phase: "secondary_talk_recipient"
                        }
                    ]
                },
                {
                    id: "secondary_talk_recipient",
                    phase: "dialog",
                    view: "free_roam",
                    properties: {
                        phone: {
                            disabledApps: [
                                'contacts',
                                'agenda',
                                'files'
                            ]
                        },
                        dialog: [
                            {
                                speaker: "player",
                                text: "Hallo Stien! Ik heb vandaag een afspraak met jou. Ik ben <player.firstname> , jouw casemanager. Ik kom eens luisteren wat ik voor je kan betekenen."
                            },
                            {
                                speaker: "stien",
                                text: "Welkom <player.firstname>, kom binnen. Ik ga even koffie zetten voor ons. Kijk maar even rond, dan leer je mij al beter kennen."
                            }
                        ],
                        scene: Zoro001IntroSecondaryTalkRecipientScene
                    },
                    triggers: [
                        {
                            trigger: "dialog_end",
                            phase: "collect_items"
                        }
                    ]
                },
                {
                    id: "collect_items",
                    view: "free_roam",
                    properties: {
                        phone: {
                            disabledApps: [
                                'contacts',
                                'agenda',
                                'files'
                            ]
                        },
                        location: "hallway",
                        recipient: "kitchen",
                        scene: Zoro001IntroCollectItemsScene
                    },
                    actions: [
                        {
                            action: "collect_item"
                        },
                        {
                            action: "move_location"
                        }
                    ],
                    triggers: [
                        {
                            trigger: "all_items_collected",
                            phase: "find_recipient"
                        }
                    ]
                },
                {
                    id: "find_recipient",
                    view: "free_roam",
                    properties: {
                        phone: {
                            disabledApps: [
                                'contacts',
                                'agenda',
                                'files'
                            ],
                            hints: [
                                {
                                    text: "Ga naar de keuken en start een gesprek met Stien.",
                                    penalty: Constants.SCORE_TYPES.INTRA_PRENEURSHIP
                                }
                            ]
                        },
                        notification: {
                            app: "sms",
                            header: {
                                icon: require("@/assets/images/UI/phone/icon_sms.png"),
                                title: "SMS"
                            },
                            body: {
                                title: "Stien:",
                                description: "Koffie is klaar! Ik zie je in de keuken."
                            },
                            callToAction: {
                                text: "OK"
                            }
                        },
                        scene: Zoro001IntroFindRecipientScene
                    },
                    actions: [
                        {
                            action: "talk_with_recipient",
                            phase: "goal_seeker_prep_talk"
                        }
                    ]
                },
                {
                    id: "goal_seeker_prep_talk",
                    phase: "dialog",
                    view: 'free_roam',
                    properties: {
                        phone: {
                            disabledApps: [
                                'contacts',
                                'agenda',
                                'files'
                            ]
                        },
                        dialog: [
                            {
                                speaker: "player",
                                text: "Bedankt dat ik even mocht rondkijken. We gaan nu een doelzoeker opstellen. Via deze methode leer ik jou beter kennen en ontdekken we wat op dit moment je levensdoelen zijn."
                            }
                        ],
                        scene: Zoro001IntroStepWrapUpTalkScene
                    },
                    triggers: [
                        {
                            trigger: "dialog_end",
                            phase: "goal_seeker"
                        }
                    ]
                },
                {
                    id: "goal_seeker",
                    phase: "goal_seeker",
                    view: "free_roam",
                    properties: {
                        phone: {
                            disabledApps: [
                                'contacts',
                                'agenda',
                                'files'
                            ]
                        },
                        scene: Zoro001IntroGoalSeekerScene
                    },
                    actions: [
                        {
                            action: "click_past",
                            phase: "goal_seeker_past"
                        },
                        {
                            action: "click_present",
                            phase: "goal_seeker_present"
                        },
                        {
                            action: "click_future",
                            phase: "goal_seeker_future"
                        }
                    ],
                    triggers: [
                        {
                            trigger: "goal_seeker_completed",
                            phase: "goal_seeker_wrap_up_talk"
                        }
                    ]
                },
                {
                    id: "goal_seeker_past",
                    phase: "dialog",
                    view: "free_roam",
                    properties: {
                        phone: {
                            disabledApps: [
                                'contacts',
                                'agenda',
                                'files'
                            ]
                        },
                        dialog: [
                            {
                                speaker: "player",
                                text: "Van welke dingen kon je vroeger echt genieten?"
                            },
                            {
                                speaker: "stien",
                                text: "Ik werkte heel graag in de tuin. Wanneer ik tussen mijn bloemen zat, was ik echt gelukkig. Bij slecht weer kon je mij steeds achter mijn schildersezel vinden."
                            }
                        ],
                        scene: Zoro001IntroGoalSeekerPastScene
                    },
                    triggers: [
                        {
                            trigger: "dialog_end",
                            phase: "goal_seeker"
                        }
                    ]
                },
                {
                    id: "goal_seeker_present",
                    phase: "dialog",
                    view: "free_roam",
                    properties: {
                        phone: {
                            disabledApps: [
                                'contacts',
                                'agenda',
                                'files'
                            ]
                        },
                        dialog: [
                            {
                                speaker: "player",
                                text: "Waar ben je momenteel mee bezig en is belangrijk voor je?"
                            },
                            {
                                speaker: "stien",
                                text: "Ik ben enorm fier dat ik ondanks mijn beroerte nog steeds voor mezelf kan zorgen. Ik vraag niet graag om hulp."
                            }
                        ],
                        scene: Zoro001IntroGoalSeekerPresentScene,
                    },
                    triggers: [
                        {
                            trigger: "dialog_end",
                            phase: "goal_seeker"
                        }
                    ]
                },
                {
                    id: "goal_seeker_future",
                    phase: "dialog",
                    view: "free_roam",
                    properties: {
                        phone: {
                            disabledApps: [
                                'contacts',
                                'agenda',
                                'files'
                            ]
                        },
                        dialog: [
                            {
                                speaker: "player",
                                text: "Wat zijn jouw uitdagingen in de toekomst?"
                            },
                            {
                                speaker: "stien",
                                text: "Mijn familie is het belangrijkste in mijn leven. Jan wil graag met de fiets gaan werken, maar hij doet dit niet omdat hij mij dan langer alleen moet laten."
                            }
                        ],
                        scene: Zoro001IntroGoalSeekerFutureScene
                    },
                    triggers: [
                        {
                            trigger: "dialog_end",
                            phase: "goal_seeker"
                        }
                    ]
                },
                {
                    id: "goal_seeker_wrap_up_talk",
                    phase: "dialog",
                    view: "free_roam",
                    properties: {
                        phone: {
                            disabledApps: [
                                'contacts',
                                'agenda',
                                'files'
                            ],
                        },
                        dialog: [
                            {
                                speaker: "stien",
                                text: "De doelzoeker heeft mij laten inzien dat zowel het verleden, het heden en de toekomst belangrijke momenten zijn om bij stil te staan. Ik weet nu veel beter wat mijn levensdoelen zijn. Dankzij de doelzoeker heb ik verder nagedacht over zaken die ik wil aanpakken. Ik zou het enorm fijn vinden mocht Jan onbezorgd met de fiets naar het werk kunnen gaan."
                            }
                        ],
                        scene: Zoro001IntroGoalSeekerWrapUpTalkScene
                    },
                    triggers: [
                        {
                            trigger: "dialog_end",
                            phase: "step_wrap_up_talk"
                        }
                    ]
                },
                {
                    id: "step_wrap_up_talk",
                    phase: "dialog",
                    view: "free_roam",
                    properties: {
                        phone: {
                            disabledApps: [
                                'contacts',
                                'agenda',
                                'files'
                            ]
                        },
                        dialog: [
                            {
                                speaker: "player",
                                text: "Begrijp ik het goed dat jouw zorgvraag de volgende is: Je wil dat je partner en kinderen zich geen zorgen hoeven te maken als je alleen thuis bent. Op deze manier behoud je je zelfstandigheid."
                            },
                            {
                                speaker: "stien",
                                text: "Ja, dat klopt <player.firstname>."
                            },
                            {
                                speaker: "player",
                                text: "Oké, bedankt voor alle informatie. Ik ga meteen aan de slag en hou je op de hoogte. Bedankt voor je tijd en tot ziens!"
                            }
                        ],
                        scene: Zoro001IntroStepWrapUpTalkScene
                    },
                    triggers: [
                        {
                            trigger: "dialog_end",
                            phase: "conclusion"
                        }
                    ]
                },
                {
                    id: "conclusion",
                    phase: "conclusion",
                    view: "free_roam",
                    properties: {
                        conclusion: {
                            title: "1. Kennismaking en zorgvraag cliënt",
                            description: "<p>Je hebt het eerste deel van je zorgplan ingevuld. Je hebt de<strong> zorgontvanger beter leren</strong> <strong>kennen</strong>.</p>\n" +
                                "<p>De<strong> doelzoeker</strong> helpt de zorgontvanger om na te denken over wat belangrijk is in het leven en wat levenskwaliteit biedt. Het helpt om concrete <strong>levensdoelen</strong> te formuleren die de zorgontvanger kan gebruiken in gesprek met zorgverleners. De doelzoeker werd ontwikkeld door het<strong> Vlaams Pati&euml;ntenplatform</strong>. Meer info staat op de gsm onder 'Info'.</p>\n" +
                                "<p>Je <strong>onderzocht en signaleerde</strong> een <strong>zorgvraag</strong>. Nu weet je wat de zorgontvanger wil bereiken.</p>",
                            infoKeys: [ 'background-info', 'care-question', 'score-intra' ],
                            buttonText: "Bekijk dossier"
                        },
                        scene: Zoro001IntroStepWrapUpTalkScene
                    },
                    actions: [
                        {
                            action: "next_step",
                            step: "assembly"
                        }
                    ],
                }
            ],
            points: new GameScore({
                intrapreneurship: 3
            }),
            fixedPoints: new GameScore({
                intrapreneurship: 3
            })
        },
        {
            id: "assembly",
            name: "Zorgteam samenstellen",
            includeTodo: true,
            documents: [],
            phases: [
                {
                    id: "dashboard",
                    view: "dashboard",
                    properties: {
                        phone: {
                            hints: [
                                {
                                    text: "Stel een zorgteam samen door naar je Contacten te gaan en kies voor 'Zorgteam aanmaken'",
                                    penalty: Constants.SCORE_TYPES.INTRA_PRENEURSHIP
                                }
                            ]
                        },
                        notification: {
                            app: "agenda",
                            header: {
                                icon: require("@/assets/images/UI/phone/icon_calendar.png"),
                                title: "Agenda"
                            },
                            body: {
                                title: "Reminder",
                                description: "Stel een zorgteam samen voor Stien."
                            },
                            callToAction: {
                                text: "Zorgteam samenstellen",
                                action: "click_assembly"
                            },
                            idleTime: 10000,
                            autoDisplay: 20000
                        }
                    },
                    actions: [
                        {
                            action: "click_assembly",
                            phase: "contact_assembly"
                        }
                    ],
                    triggers: []
                },
                {
                    id: "contact_assembly",
                    view: "contacts",
                    title: "Contacten",
                    properties: {
                        meeting_type: "online"
                    },
                    actions: [
                        {
                            action: "start_meeting",
                            phase: "heading_to_meeting"
                        }
                    ]
                },
                {
                    id: "heading_to_meeting",
                    view: "calling",
                    title: "Teamgesprek zorgteam Stien",
                    triggers: [
                        {
                            trigger: "load-phase",
                            auto: true,
                            duration: 2000,
                            phase: "call"
                        }
                    ]
                },
                {
                    id: "call",
                    view: "call",
                    title: "Teamgesprek zorgteam Stien",
                    properties: {
                        meeting_type: "online",
                        initial_dialog_wrong: "Hallo allemaal, ik heb jullie samengebracht als zorgteam voor Stien. Ik wil even afstemmen of jullie je hierin kunnen vinden?",
                        initial_dialog_correct: "Wat bevelen jullie aan voor Stien vanuit jullie context? En Stien, wat denk jij over deze aanbevelingen?",
                        negativeFeedback: [
                            "Ik denk dat ik voor deze case weinig zal kunnen betekenen.",
                            "Misschien dat een ander type zorgverlener is aangewezen.",
                            "Sorry, ik kan me hierin niet vinden.",
                            "Ik kan weinig professionele meerwaarde bieden aan dit team.",
                            "Sorry, ik vrees dat ik hier weinig input zal kunnen bieden.",
                            "Mijn excuses, maar ik denk dat ik hier niet op mijn plaats zit.",
                            "Ik ben ervan overtuigd dat anderen hier meer van weten.",
                            "Bedankt voor de uitnodiging, maar hierbij kan ik je echt niet verder helpen.",
                            "Geen idee hoe je bij mij komt. Ik ben niet de juiste persoon.",
                            "Deze vraag is zeer interessant, maar volledig buiten mijn expertisegebied.",
                            "Dit is niets voor mij. Veel succes met het zoeken naar een andere zorgverlener."
                        ],
                        positiveFeedback: [
                            "Ik kan me hierin wel vinden.",
                            "Lijkt me logisch dat je me hebt toegevoegd.",
                            "Oké voor mij.",
                            "Ja, hoor.",
                            "Ik wil absoluut helpen nadenken over een gepaste oplossing voor Stien.",
                            "Bedankt voor de uitnodiging, ik kijk er naar uit om samen te werken.",
                            "Dit is helemaal iets voor mij.",
                            "Deze vraag is interessant en past binnen mijn expertisegebied.",
                            "Super, ik doe mee.",
                            "Ik ga de uitdaging aan."
                        ],
                        missingRecipient: "Het is misschien een goed idee om de zorgontvanger hier ook bij te betrekken. Heb je er al aan gedacht om Stien uit te nodigen voor dit gesprek?",
                        recommendations: [
                            {
                                person: Zoro001Stien,
                                recommendation: 'Ik ben niet hulpeloos. Ik wil een hoogtechnologische oplossing die mij het leven makkelijker maakt en die de zorgen van mijn familie wegneemt.'
                            },
                            {
                                person: Zoro001Guy,
                                recommendation: 'Ik merk uit de gesprekken met Stien dat ze haar familie wil geruststellen. Stien is een moderne vrouw dus een technologische oplossing is zeker aangewezen.'
                            },
                            {
                                person: Zoro001Annika,
                                recommendation: 'Ik ben voornamelijk bezig met de stabiliteit van Stien. Ik zou het dus goed vinden moesten we werken aan haar zelfstandigheid door in te zetten op oefeningen rond evenwicht.'
                            },
                            {
                                person: Zoro001Amina,
                                recommendation: 'Als ik de zorgvraag van Stien hoor, denk ik dat de informatie die ik gekregen heb tijdens de ZORO-training wel van nut kan zijn. Ik heb hier geleerd om gepaste technologische hulpmiddelen te vinden voor allerlei situaties. Ik stuur de link naar de informatie door naar jou, <player.firstname>.',
                                mentionZoroWebsiteLink: true
                            },
                            {
                                person: Zoro001Jack,
                                recommendation: 'Ik kan op een later tijdstip meehelpen denken over het juiste technologische hulpmiddel. Ik heb namelijk het huis helpen aanpassen na de hersenbloeding van Stien.'
                            },
                            {
                                person: Zoro001Jan,
                                recommendation: 'Ik ben nu heel de dag weg voor het werk. Ik maak mij zorgen over haar veiligheid. Stel dat er iets gebeurt: ze valt en is bewusteloos?'
                            }
                        ]
                    },
                    actions: [
                        {
                            action: "make_correction",
                            phase: "contact_assembly"
                        },
                        {
                            action: "finish_meeting",
                            phase: "conclusion"
                        }
                    ]
                },
                {
                    id: "conclusion",
                    phase: "conclusion",
                    view: "call",
                    properties: {
                        conclusion: {
                            title: "2. Stel een zorgteam samen",
                            description: "<p>Een team kies je op basis van de noden van je zorgontvanger. <strong>Wie kan er bij deze vraag</strong> <strong>het beste helpen?</strong> Dankzij het teamoverleg ga je in <strong>overleg</strong> en werk je<strong> samen</strong> met de <strong>verschillende disciplines</strong> en de <strong>zorgontvanger</strong> aan een <strong>gemeenschappelijk doel</strong>. Dit zorgt ervoor dat je echt kwalitatieve zorg op maat kan bieden!</p>",
                            infoKeys: [ 'care-team-added', 'recommendation-added', 'score-intra', 'score-is' ],
                            buttonText: "Bekijk dossier"
                        }
                    },
                    actions: [
                        {
                            action: "next_step",
                            step: "technology"
                        }
                    ]
                }
            ],
            points: new GameScore({
                intrapreneurship: 3,
                interprofessionalCollaboration: 15
            }),
            fixedPoints: new GameScore({
                intrapreneurship: 3,
                interprofessionalCollaboration: 15
            })
        },
        {
            id: "technology",
            name: "Technologische hulpmiddelen",
            includeTodo: true,
            documents: [],
            phases: [
                {
                    id: "dashboard",
                    view: "dashboard",
                    properties: {
                        phone: {
                            hints: [
                                {
                                    text: "Bekijk de link met aanbevelingen van het zorgteam voor technologische hulpmiddelen in 'Bestanden'.",
                                    penalty: Constants.SCORE_TYPES.INTRA_PRENEURSHIP
                                }
                            ]
                        },
                        notification: {
                            app: "files",
                            header: {
                                icon: require("@/assets/images/UI/phone/icon_files.png"),
                                title: "Bestanden"
                            },
                            body: {
                                title: "Reminder",
                                description: "Zoek een technologische oplossing voor Stien. Zie 'Aanbevelingen'."
                            },
                            callToAction: {
                                type: "files",
                                text: "Open bestanden",
                                action: "click_files"
                            },
                            idleTime: 10000,
                            autoDisplay: 20000
                        }
                    },
                    actions: [
                        {
                            action: "click_files",
                            phase: "view_files"
                        }
                    ]
                },
                {
                    id: "view_files",
                    view: "documents",
                    title: "Bestanden",
                    properties: {
                        documents: [
                            "recommendations"
                        ],
                        selectedDocument: "recommendations"
                    },
                    actions: [
                        {
                            action: "click_website_link",
                            phase: "website_view"
                        }
                    ]
                },
                {
                    id: "website_view",
                    view: "website_view",
                    title: "https://www.hulpmiddelen.com",
                    titleType: "url",
                    properties: {
                        meeting_type: "online"
                    },
                    actions: [
                        {
                            action: "start_meeting",
                            phase: "heading_to_meeting"
                        }
                    ]
                },
                {
                    id: "heading_to_meeting",
                    view: "calling",
                    title: "Teamgesprek zorgteam Stien",
                    triggers: [
                        {
                            trigger: "load-phase",
                            auto: true,
                            duration: 2000,
                            phase: "call"
                        }
                    ]
                },
                {
                    id: "call",
                    view: "call",
                    title: "Teamgesprek zorgteam Stien",
                    properties: {
                        meeting_type: "online",
                        initial_dialog: "Wat vinden jullie van deze selectie hulpmiddelen voor Stien?",
                        technologicalAidsResponses: [
                            {
                                technologicalAid: Lamp,
                                questioner: Zoro001Amina,
                                question: "Is een lamp die gaat branden bij beweging een hulp voor jou?",
                                answer: "Dit lijkt me een zeer nuttige toepassing. Ik denk echter dat het mij onvoldoende zal helpen bij mijn problematiek."
                            },
                            {
                                technologicalAid: Phone,
                                questioner: Zoro001Jack,
                                question: "Denk je dat een vaste telefoon met grote fototoetsen je kan helpen?",
                                answer: "Ik vrees dat dit niet is wat ik zoek. Ik zie niet in hoe dit mijn zelfstandigheid en mobiliteit kan vooruit helpen."
                            },
                            {
                                technologicalAid: Airbag,
                                questioner: Zoro001Annika,
                                question: "Ben je bereid om een bekken airbag te dragen onder je kleding?",
                                answer: "Ik zie het niet haalbaar om deze bekken airbag continu te dragen, zeker niet in de zomer.",
                            },
                            {
                                technologicalAid: Smartclip,
                                questioner: Zoro001Jan,
                                question: "Kan je werken met een app met zoveel toepassingen?",
                                answer: "Werken met een app vind ik fijn en schrikt me niet af. Ik krijg heel wat informatie over mijn bewegingspatroon en wanneer het valrisico dreigt toe te nemen. De clip kan ik discreet dragen. Niemand hoeft hem te zien.",
                            },
                            {
                                technologicalAid: LifestyleDetector,
                                questioner: Zoro001Guy,
                                question: "Wat vind je ervan dat anderen je leefpatroon kunnen gaan opvolgen?",
                                answer: "Ik voel me daar niet zo goed bij. Ik wil in zekere zin toch mijn privacy en zelfstandigheid gaan behouden. Ik woon hier ook niet alleen.",
                            },
                            {
                                technologicalAid: Stairgate,
                                questioner: Zoro001Amina,
                                question: "Is een traphekje een goede oplossing voor jou?",
                                answer: "Dit is totaal niet wat ik zoek. Ik denk dat je best nog eens mijn hulpvraag bekijkt.",
                            },
                            {
                                technologicalAid: FallDetectionShoes,
                                questioner: Zoro001Annika,
                                question: "Wat zou je ervan vinden om deze schoenen te dragen?",
                                answer: "Ik draag graag verschillende schoenen en dit model lijkt me niet zo leuk om elke dag te dragen.",
                            },
                            {
                                technologicalAid: EWheelChair,
                                questioner: Zoro001Guy,
                                question: "Is je huis in orde om je  met een elektrische rolstoel te verplaatsen?",
                                answer: "Dit zou lukken, maar ik wil niet continu in een elektrische rolstoel zitten. Ik wil mijn spieren blijven trainen.",
                            },
                            {
                                technologicalAid: Walker,
                                questioner: Zoro001Jan,
                                question: "Lukt het voor jou om met een rollator te stappen?",
                                answer: "Ik kan maar 1 hand goed gebruiken, waardoor een rollator voor mij niet werkt.",
                            },
                            {
                                technologicalAid: SpeakerCamera,
                                questioner: Zoro001Jack,
                                question: "Je familieleden houden mee een oogje in het zeil. Ze zien hoe en waar je beweegt in huis. Ze kunnen met je spreken indien nodig. Is dat oké voor jou?",
                                answer: "De gedachte dat ze me kunnen zien, vind ik niet zo leuk.",
                            }
                        ],
                        closing_dialog: [
                            {
                                person: Zoro001Guy,
                                text: "Ik ben zeer benieuwd. De volgende keer als je op consultatie komt, bekijken we samen de valrisicometer en dan passen we je oefeningen hierop aan."
                            },
                            {
                                person: Zoro001Annika,
                                text: "Het is heel positief dat we je bewegingspatroon mee kunnen opvolgen en zeer gericht te werk kunnen gaan."
                            },
                            {
                                person: Zoro001Amina,
                                text: "Ik vind het positief dat niemand kan zien dat je deze clip draagt."
                            },
                            {
                                person: Zoro001Jan,
                                text: "Ik ben gerustgesteld dat we een alarm zullen krijgen, mocht er iets gebeuren."
                            },
                            {
                                person: Zoro001Jack,
                                text: "Ik vind het sterk dat een val gedetecteerd wordt. Als zorgontvanger hoef je niets te doen. De juiste mensen krijgen een melding."
                            },
                            {
                                person: Zoro001Stien,
                                text: "Ik ben tevreden dat ik via de app veel informatie zal krijgen over mijn bewegingspatroon. Zo weten we of het valrisico toeneemt of niet. Het is ook zeer discreet . Deze clip wil ik zeker uitproberen."
                            }
                        ]
                    },
                    actions: [
                        {
                            action: "make_correction",
                            phase: "website_view"
                        },
                        {
                            action: "finish_meeting",
                            phase: "conclusion"
                        }
                    ]
                },
                {
                    id: "conclusion",
                    phase: "conclusion",
                    view: "call",
                    properties: {
                        conclusion: {
                            title: "3. Technologische hulpmiddelen",
                            description: "<p>Bij het zoeken naar <strong>geschikte zorgtechnologie</strong> is het belangrijk om de gebruiker van de technologie goed te <strong>bevragen</strong>. Die moet immers het voordeel zien en de technologie willen gebruiken. Als zorgverlener kan je je mening geven, maar de <strong>eindbeslissing ligt steeds bij de zorgontvanger.</strong></p>\n" +
                                "<p>Je hebt <strong>kritisch geluisterd</strong> naar het zorgteam en de wensen van de zorgontvanger. Zo kwam je bij een <strong>zorgoplossing op maat</strong>. De zorgontvanger zelf heeft ook hier steeds een belangrijke rol!</p>",
                            infoKeys: [ 'tech-added', 'score-tw', 'score-intra', 'score-is' ],
                            buttonText: "Bekijk dossier"
                        }
                    },
                    actions: [
                        {
                            action: "next_step",
                            step: "followup"
                        }
                    ]
                }
            ],
            points: new GameScore({
                technicalManeuverability: 15,
                intrapreneurship: 3,
                interprofessionalCollaboration: 3
            }),
            fixedPoints: new GameScore({
                technicalManeuverability: 15,
                intrapreneurship: 3,
                interprofessionalCollaboration: 3
            })
        },
        {
            id: "followup",
            name: "Follow up & ethiek",
            includeTodo: true,
            documents: [
                'recommendations'
            ],
            phases: [
                {
                    id: "dashboard",
                    view: "dashboard",
                    properties: {
                        phone: {
                            hints: [
                                {
                                    text: "Bezoek je cliënt voor een follow-up.",
                                    penalty: Constants.SCORE_TYPES.INTRA_PRENEURSHIP
                                }
                            ]
                        },
                        notification: {
                            app: "agenda",
                            header: {
                                icon: require("@/assets/images/UI/phone/icon_calendar.png"),
                                title: "Agenda"
                            },
                            body: {
                                title: "Reminder",
                                description: "Follow up - Bezoek Stien en bekijk ethische aspect."
                            },
                            callToAction: {
                                type: "location",
                                text: "Bezoek Stien",
                                action: "visit_recipient"
                            },
                            idleTime: 10000,
                            autoDisplay: 20000
                        }
                    },
                    actions: [
                        {
                            action: "visit_recipient",
                            phase: "heading_to_recipient"
                        }
                    ]
                },
                {
                    id: "heading_to_recipient",
                    view: "gps",
                    title: "GPS",
                    properties: {
                        location: "test"
                    },
                    triggers: [
                        {
                            trigger: "load-phase",
                            auto: true,
                            duration: 2000,
                            phase: "initial_home"
                        }
                    ]
                },
                {
                    id: "initial_home",
                    view: "free_roam",
                    properties: {
                        phone: {
                            hints: [
                                {
                                    text: "Je bent  aangekomen bij je cliënt. Druk op de deurbel.",
                                    penalty: Constants.SCORE_TYPES.INTRA_PRENEURSHIP
                                }
                            ]
                        },
                        location: "outside",
                        objects: [
                            "doorbell"
                        ],
                        scene: Zoro001FollowupInitialHomeScene,
                    },
                    actions: [
                        {
                            action: "press_doorbell",
                            phase: "initial_home_waiting"
                        }
                    ]
                },
                {
                    id: "initial_home_waiting",
                    view: "free_roam",
                    properties: {
                        phone: {
                            disabledApps: [
                                'contacts',
                                'agenda',
                                'files'
                            ]
                        },
                        scene: Zoro001IntroInitialHomeScene,
                    },
                    triggers: [
                        {
                            trigger: "load-phase",
                            auto: true,
                            duration: 2000,
                            phase: "first_talk_recipient"
                        }
                    ]
                },
                {
                    id: "first_talk_recipient",
                    view: "free_roam",
                    properties: {
                        phone: {
                            hints: [
                                {
                                    text: "Praat met Stien.",
                                    penalty: Constants.SCORE_TYPES.INTRA_PRENEURSHIP
                                }
                            ]
                        },
                        location: "hallway",
                        objects: [
                            "recipient"
                        ],
                        scene: Zoro001FollowupFirstTalkRecipientScene
                    },
                    actions: [
                        {
                            action: "talk_with_recipient",
                            phase: "secondary_talk_recipient"
                        }
                    ]
                },
                {
                    id: "secondary_talk_recipient",
                    phase: "dialog",
                    view: "free_roam",
                    properties: {
                        dialog: [
                            {
                                speaker: "player",
                                text: "Hallo Stien! Hoe gaat het met jou?"
                            },
                            {
                                speaker: "stien",
                                text: "Hoi <player.firstname>, met mij gaat het heel goed. Ik ben erg tevreden met de oplossing die jullie hebben voorgesteld."
                            },
                            {
                                speaker: "stien",
                                text: "Ik zal een kopje koffie zetten, dan kunnen we bijpraten.\nKijk gerust rond, geen probleem."
                            }
                        ],
                        scene: Zoro001FollowupSecondaryTalkRecipientScene
                    },
                    triggers: [
                        {
                            trigger: "dialog_end",
                            phase: "collect_items"
                        }
                    ]
                },
                {
                    id: "collect_items",
                    view: "free_roam",
                    properties: {
                        phone: {},
                        location: "hallway",
                        recipient: "kitchen",
                        scene: Zoro001FollowupCollectItemsScene
                    },
                    actions: [
                        {
                            action: "collect_item"
                        },
                        {
                            action: "move_location"
                        }
                    ],
                    triggers: [
                        {
                            trigger: "all_items_collected",
                            phase: "find_recipient"
                        }
                    ]
                },
                {
                    id: "find_recipient",
                    view: "free_roam",
                    properties: {
                        phone: {
                            hints: [
                                {
                                    text: "Ga naar de keuken en start een gesprek met Stien.",
                                    penalty: Constants.SCORE_TYPES.INTRA_PRENEURSHIP
                                }
                            ]
                        },
                        notification: {
                            app: "sms",
                            header: {
                                icon: require("@/assets/images/UI/phone/icon_sms.png"),
                                title: "SMS"
                            },
                            body: {
                                title: "Stien:",
                                description: "Koffie is klaar! Ik zie je in de keuken."
                            },
                            callToAction: {
                                text: "OK"
                            }
                        },
                        scene: Zoro001FollowupFindRecipientScene
                    },
                    actions: [
                        {
                            action: "talk_with_recipient",
                            phase: "talk_about_items"
                        }
                    ]
                },
                {
                    id: "talk_about_items",
                    phase: "dialog",
                    view: "free_roam",
                    properties: {
                        dialog: [
                            {
                                speaker: "player",
                                text: "Zo Stien, bedankt voor alle informatie. Ik bezorg jou en de rest van het zorgteam zo snel mogelijk jouw zorgplan. Hou je goed en tot ziens!"
                            },
                            {
                                speaker: "stien",
                                text: "Hartelijk dank voor al je werk <player.firstname>. Tot ziens!"
                            }
                        ],
                        scene: Zoro001FollowupTalkAboutItemsScene
                    },
                    triggers: [
                        {
                            trigger: "dialog_end",
                            phase: "conclusion"
                        }
                    ]
                },
                {
                    id: "conclusion",
                    phase: "conclusion",
                    view: "free_roam",
                    properties: {
                        conclusion: {
                            title: "4. Follow up en ethiek",
                            description: "<p>Ethisch handelen gaat niet (enkel) over grote ethische vraagstukken, maar om het streven naar <strong>het goede in de alledaagse zorg</strong>. Het gaat om<strong> zorg die deugd doet aan beide kanten van de zorgrelatie</strong>, want alleen door een <strong>betrokken</strong> relatie met de zorgontvanger aan te gaan, kan je ontdekken wat goede zorg voor hem of haar betekent.&nbsp;</p>\n" +
                                "<p>Je hebt je verbeterplan <strong>omgezet in een actie</strong>! En de zorgontvanger is tevreden.</p>",
                            infoKeys: [ 'eh-added', 'score-intra', 'score-eh' ],
                            buttonText: "Bekijk dossier"
                        },
                        scene: Zoro001IntroStepWrapUpTalkScene
                    },
                    actions: [
                        {
                            action: "next_step",
                            step: "plan"
                        }
                    ]
                }
            ],
            points: new GameScore({
                intrapreneurship: 3,
                actingEthically: 15
            }),
            fixedPoints: new GameScore({
                intrapreneurship: 3,
                actingEthically: 15
            })
        },
        {
            id: "plan",
            name: "Zorgplan opleveren",
            includeTodo: true,
            documents: [
                'recommendations'
            ],
            phases: [
                {
                    id: "dashboard",
                    view: "dashboard",
                    properties: {
                        phone: {
                            hints: [
                                {
                                    text: "Je hebt je zorgplan opgesteld en opgeslagen in 'Bestanden'. Tijd om het op te sturen naar het zorgteam.",
                                    penalty: Constants.SCORE_TYPES.INTRA_PRENEURSHIP
                                }
                            ]
                        },
                        notification: {
                            app: "files",
                            header: {
                                icon: require("@/assets/images/UI/phone/icon_files.png"),
                                title: "Bestanden"
                            },
                            body: {
                                title: "Reminder",
                                description: "E-mail het zorgplan naar het zorgteam en de zorgvrager."
                            },
                            callToAction: {
                                type: "files",
                                text: "Open bestanden",
                                action: "click_files"
                            },
                            idleTime: 10000,
                            autoDisplay: 20000
                        }
                    },
                    actions: [
                        {
                            action: "click_files",
                            phase: "view_files"
                        }
                    ]
                },
                {
                    id: "view_files",
                    view: "documents",
                    title: "Bestanden",
                    properties: {
                        documents: [
                            "recommendations",
                            "careplan"
                        ],
                        selectedDocument: "careplan"
                    },
                    actions: [
                        {
                            action: "email_files",
                            popup: "confirm_email"
                        },
                        {
                            action: "confirm_send_email",
                            phase: "sending_email"
                        }
                    ]
                },
                {
                    id: "sending_email",
                    view: "sending_email",
                    title: "E-Mail",
                    triggers: [
                        {
                            trigger: "load-step",
                            auto: true,
                            duration: 2000,
                            step: "game-end"
                        }
                    ]
                }
            ]
        },
        {
            id: "game-end",
            includeTodo: false,
            phases: [
                {
                    id: "dashboard",
                    view: "dashboard",
                    properties: {},
                    triggers: [
                        {
                            trigger: "game-end",
                            finishGame: true,
                            auto: true
                        }
                    ]
                }
            ]
        }
    ],
    documents: [
        {
            id: "recommendations",
            name: "Aanbevelingen",
            icon: require('@/assets/images/UI/icons/icon_doctype_zoro.png'),
            care_question: "Stien wil dat haar partner en kinderen zich geen zorgen hoeven te maken als ze alleen thuis is. Op deze manier behoudt ze haar zelfstandigheid.",
            recommendations: [
                {
                    person: Zoro001Guy,
                    recommendation: 'Ik merk uit de gesprekken met Stien dat ze haar familie wil geruststellen. Stien is een moderne vrouw dus een technologische oplossing is zeker aangewezen.'
                },
                {
                    person: Zoro001Annika,
                    recommendation: 'Ik ben voornamelijk bezig met de stabiliteit van Stien. Ik zou het dus goed vinden moesten we werken aan haar zelfstandigheid door in te zetten op oefeningen rond evenwicht.'
                },
                {
                    person: Zoro001Amina,
                    recommendation: 'Als ik de zorgvraag van Stien hoor, denk ik dat de informatie die ik gekregen heb tijdens de ZORO-training wel van nut kan zijn. Ik heb hier geleerd om gepaste technologische hulpmiddelen te vinden voor allerlei situaties. Ik stuur de link naar de informatie door naar jou, <player.firstname>.',
                },
                {
                    person: Zoro001Jack,
                    recommendation: 'Ik kan op een later tijdstip meehelpen denken over het juiste technologische hulpmiddel. Ik heb namelijk het huis helpen aanpassen na de hersenbloeding van Stien.'
                },
                {
                    person: Zoro001Jan,
                    recommendation: 'Ik ben nu heel de dag weg voor het werk. Ik maak mij zorgen over haar veiligheid. Stel dat er iets gebeurt: ze valt en is bewusteloos?'
                },
                {
                    person: Zoro001Stien,
                    recommendation: 'Ik ben niet hulpeloos, ik wil een hoogtechnologische oplossing die mij het leven makkelijker maakt en die de zorgen van mijn familie wegnemen.'
                }
            ]
        },
        {
            id: "careplan",
            name: "Zorgplan",
            icon: require('@/assets/images/UI/icons/icon_doctype_zoro.png'),
            pdf: require('@/assets/pdfs/zorgplan_01.pdf').default,
            images: [
                require('@/assets/pdfs/zorgplan_01_1.png'),
                require('@/assets/pdfs/zorgplan_01_2.png'),
                require('@/assets/pdfs/zorgplan_01_3.png')
            ],
            actions: [ "email", "download" ]
        }
    ],
    document: {
        situationInstructions: "Bezoek Stien en kom te weten wat haar situatie en zorgvraag is.<br>Ga op zoek naar 6 objecten om Stien beter te leren kennen.",
        careInstructions: "Stel een zorgteam samen om Stien haar zorgvraag aan te pakken",
        techAidInstructions: "Adviseer een technologisch hulpmiddel voor Stien op basis van haar zorgvraag en aanbevelingen van het zorgteam",
        ethicalInstructions: "Ga langs bij Stien voor een follow-upgesprek met betrekking tot haar hulpmiddel. Misschien is dit een goed moment om ook het ethische aspect van haar situatie te bekijken. Ga op zoek in haar huis naar 3 ethische dilemma’s.",
        situation: "Mijn naam is Stien, 59 jaar. Ik heb een hersenbloeding gehad. Hierdoor ben ik gedeeltelijk verlamd aan mijn linkerzijde. Daardoor ben ik minder mobiel en heb ik last van evenwichtsstoornissen.<br>" +
            "<br>" +
            "Ik werkte heel graag in de tuin. Wanneer ik tussen mijn bloemen zat, was ik echt heel gelukkig. Bij slecht weer kon je mij steeds achter mijn schildersezel vinden.<br>" +
            "<br>" +
            "Ik ben enorm trots dat ik ondanks mijn hersenbloeding nog steeds voor mezelf kan zorgen. Ik vraag niet graag om hulp.<br>" +
            "<br>" +
            "Mijn familie is het belangrijkste in mijn leven. Jan, mijn partner, wil graag met de fiets gaan werken, maar hij doet dit niet omdat hij mij dan langer alleen moet laten.",
        careTeam: [
            Zoro001Stien,
            Zoro001Amina,
            Zoro001Jan,
            Zoro001Annika,
            Zoro001Guy,
            Zoro001Jack
        ],
        collectionItems: [
            Art,
            Helmet,
            Photo,
            Dog,
            Flowers,
            Wheelchair
        ],
        careDescription: "Stien, vrouw, 59 jaar, hersenbloeding, linkerzijde gedeeltelijk verlamd, minder mobiel en last van evenwichtsstoornissen.",
        careQuestion: "Stien wil dat haar partner en kinderen zich geen zorgen hoeven te maken als ze alleen thuis is. Op deze manier behoudt ze haar zelfstandigheid.",
        technologicalAid: Smartclip,
        ethical: [
            {
                item: CellPhone,
                theorem: "Communicatie",
                theoremDescription: "<p>De huishoudhulp gaat langs bij Stien. Stien voelt zich niet 100% vandaag. De huishoudhulp besluit een WhatsApp-berichtje te sturen:</p>\n" +
                    "<p><em>\"Beste collega, Stien heeft een slechte dag vandaag. Morgen heb ik vrijaf en ga jij bij Stien langs. Ik maak me zorgen om Stien. Is het mogelijk om me morgen te laten weten hoe het met haar gaat?\"</em></p>\n" +
                    "<p>Is het een goed idee om dit berichtje naar je collega te sturen?</p>",
                feedbackYes: "<p>Je gaf een fout antwoord: deze stelling is ethisch niet verantwoord.</p>\n" +
                    "<p>Wanneer je je zorgen maakt over de gezondheidstoestand van Stien is het belangrijk dat alle disciplines hierover ge&iuml;nformeerd worden. Deze communicatie voer je via het beveiligde (elektronisch) patiëntendossier van je organisatie. Op deze manier is iedereen op de hoogte en ligt de verantwoordelijkheid bij je collega. Hou je work-life balance in evenwicht en geniet van je vrije dag.</p>",
                feedbackNo: "<p>Correct!</p>\n" +
                    "<p>Wanneer je je zorgen maakt over de gezondheidstoestand van Stien is het belangrijk dat alle disciplines hierover ge&iuml;nformeerd worden. Deze communicatie voer je via het beveiligde (elektronisch) patiëntendossier van je organisatie. Op deze manier is iedereen op de hoogte en ligt de verantwoordelijkheid bij je collega. Hou je work-life balance in evenwicht en geniet van je vrije dag.</p>",
                ethical: "Nee",
                correctAnswers: [ "no" ]
            },
            {
                item: Gift,
                theorem: "Verjaardagscadeau",
                theoremDescription: "<p>Je werkt al 2 jaar als vaste zorgverlener voor Stien. Stien weet dat het jouw verjaardag is en wil je verrassen met een cadeaubon.</p>\n" +
                    "<p>Is het ethisch verantwoord om dit cadeau aan te nemen?</p>",
                feedbackYes: "<p>Het antwoord is niet zo eenduidig.</p>\n" +
                    "<p>Als zorgverlener mag je geen geschenk van de zorgontvanger accepteren dat meer is dan een symbolisch gebaar van dank. Dit maakt het meteen lastig, want wat is een symbolisch gebaar? Vraag bij je organisatie wat het beleid hierover is.</p>",
                feedbackNo: "<p>Het antwoord is niet zo eenduidig</p>\n" +
                    "<p>Als zorgverlener mag je geen geschenk van de zorgontvanger accepteren dat meer is dan een symbolisch gebaar van dank. Dit maakt het meteen lastig, want wat is een symbolisch gebaar? Vraag bij je organisatie wat het beleid hierover is.</p>",
                ethical: "Ja en Nee",
                correctAnswers: [ "yes", "no" ]
            },
            {
                item: Datasheet,
                theorem: "Gegevens Smartclip",
                theoremDescription: "<p>Stien lijkt de laatste weken minder actief. Je maakt je als zorgverlener zorgen. Je wil graag haar bewegingspatroon inkijken.</p>\n" +
                    "<p>Mag je als zorgverlener zonder toestemming van Stien de gegevens uit de Smartclip inkijken?</p>",
                feedbackYes: "<p>Je gaf een fout antwoord: deze stelling is ethisch niet verantwoord</p>\n" +
                    "<p>Het is belangrijk dat je toestemming vraagt aan de zorgontvanger voor je de gegevens inkijkt. Ga in gesprek met de zorgontvanger.</p>",
                feedbackNo: "<p>Correct</p>\n" +
                    "<p>Het is belangrijk dat je toestemming vraagt aan de zorgontvanger voor je de gegevens inkijkt. Ga in gesprek met de zorgontvanger.</p>",
                ethical: "Nee",
                correctAnswers: [ "no" ]
            }
        ]
    },
});